// extracted by mini-css-extract-plugin
export default {"canvas":"MobileMenu_canvas__B7Pe6","header":"MobileMenu_header__N6UaB","body":"MobileMenu_body__ZoxBK","menuItem":"MobileMenu_menuItem__H7nbO"};